import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'

export const useSenderDetailsContext = () => useRcsWizardContext().senderStore
